var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAfghanistan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_49_180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9348 1.24033C16.2914 0.445703 14.4478 0 12.5 0C10.5522 0 8.70859 0.445703 7.06523 1.24033L5.97827 12.5L7.06523 23.7597C8.70859 24.5543 10.5522 25 12.5 25C14.4478 25 16.2914 24.5543 17.9348 23.7597L19.0217 12.5L17.9348 1.24033Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.06523 1.24077C2.88408 3.26259 0 7.54428 0 12.5C0 17.4557 2.88408 21.7374 7.06523 23.7592V1.24077Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9348 1.24077V23.7592C22.1159 21.7374 25 17.4557 25 12.5C25 7.54428 22.1159 3.26259 17.9348 1.24077Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.1522C10.0987 8.1522 8.15219 10.0988 8.15219 12.5C8.15219 14.9012 10.0988 16.8478 12.5 16.8478C14.9012 16.8478 16.8478 14.9012 16.8478 12.5C16.8478 10.0988 14.9013 8.1522 12.5 8.1522ZM12.5 15.2174C10.9992 15.2174 9.78261 14.0007 9.78261 12.5C9.78261 10.9993 10.9993 9.78262 12.5 9.78262C14.0007 9.78262 15.2174 10.9993 15.2174 12.5C15.2174 14.0007 14.0008 15.2174 12.5 15.2174Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.8696C11.8996 10.8696 11.413 11.3562 11.413 11.9565V13.587H13.587V11.9565C13.587 11.3562 13.1003 10.8696 12.5 10.8696Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_49_180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfghanistan);
export default __webpack_public_path__ + "static/media/afghanistan.37d1baa7398692c8932f0955da513b1b.svg";
export { ForwardRef as ReactComponent };